import {environment as base, Platform} from '@environments/base.env';

export const environment = {
  ...base,
  production: true,
  platform: Platform.WEB,
  apiUrl: '/',
  apiAuthUrl: '/',
  signtrustPath: '/personal/signtrust'
};
